import "./App.css";
import ConnectForm from "./connect/ConnectForm";

import { useEffect, useState } from "react";

type Theme = "light" | "dark";

function App() {
  const [theme] = useState<Theme>(() => {
    return localStorage.getItem("app_theme") === "dark" ? "dark" : "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("app_theme", theme);
  }, [theme]);

  return <ConnectForm />;
}

export default App;
